import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Input } from 'antd';
import { getUserByEmail, updateUser } from 'actions/superuser';

const Search = Input.Search;

import './UsersPage.css';
import { NonPsychic } from 'elements';


function mapState(state) {
  return {
    ...state.superuser
  };
}

function mapDispatch(dispatch, props) {
  return {
    getUserByEmail(email) {
      return getUserByEmail(dispatch, email);
    },
    updateUser(data) {
      return updateUser(dispatch, data);
    }
  };
}

class UsersPage extends Component {

  static propTypes = {
    fPagination: React.PropTypes.object,
    ownUUID: React.PropTypes.string,
    superuser: React.PropTypes.string,
    fConversations: React.PropTypes.array,
    getConversations: React.PropTypes.func
  };

  render() {
    const { user } = this.props;
    return (
      <div className="p-20">
        <Search
          placeholder="input user email"
          onSearch={value => this.props.getUserByEmail(value)}
          size="large"
          enterButton="Search"
        />
        {user ? <NonPsychic
          nonPsychic={user}
          addFreeQuestionFunction={() => {
            console.log('q added');
            const data = {
              email: user.email,
              freeMessages: user.freeMessages + 1
            };
            this.props.updateUser(data);
          }}
        /> : <div className="no-user">no user found</div>
        }
      </div>
    );
  }
}

export default withRouter(connect(mapState, mapDispatch)(UsersPage));



// WEBPACK FOOTER //
// ./src/pages/users/UsersPage.jsx